export default {"src":"/_next/static/image/public/images/flags/flag_356.21ebad6efaca95b1028626da6a13e929.svg","height":16,"width":24};